import RemoveIcon from '@mui/icons-material/Remove';
import { Badge, Grid, IconButton, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ContactOwner } from '../../../sic-lib/types/ContactOwner';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { UserAvatar } from '../../Settings/Users/UserAvatar';

interface Props {
    follower: ContactOwner;
    handleClick: (follower: ContactOwner) => void;
    users: UserInfo[] | undefined;
}

export function FollowerContainer({ follower, handleClick, users }: Props) {
    const { classes } = useStyles();
    const user = users?.find(x => x.userName === follower.userName);

    return (
        <Grid item>
            <IconButton onClick={() => handleClick(follower)} sx={{ p: 0 }}>
                <Badge color="error" badgeContent={<RemoveIcon />} className={classes.badge}>
                    <UserAvatar user={user} userName={follower.userName} />
                </Badge>
            </IconButton>
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    badge: {
        '&:hover .MuiBadge-badge': {
            opacity: 1,
        },

        '& .MuiBadge-badge': {
            opacity: 0,
            padding: 0,
            top: '3px',
            right: '3px',
            width: '10px',
            transition: 'opacity 0.2s ease-in-out',
        },
    },
}));
